import { Image as ImagePrimitive } from '@unpic/react/base';
import { generateImageSrc } from '@/lib/shared';
import { cn } from '@worldcoo/ui/lib/utils';
import { usePortalContext } from '@/lib/use-portal-context';

export function Image(props: {
	src: string | undefined;
	height: number;
	aspectRatio: number;
	objectFit?: 'contain' | 'cover';
	alt?: string;
	fetchPriority?: 'high' | 'low';
	className?: string;
	loading?: 'eager' | 'lazy';
}) {
	const { baseUrl } = usePortalContext();

	if (!props.src) {
		return <div className={cn(props.className, 'bg-transparent')} style={{ aspectRatio: props.aspectRatio }} />;
	}

	const src = props.src.startsWith('/') ? new URL(props.src, baseUrl).href : props.src;

	if (!import.meta.env.VITE_CDN_URL) {
		return (
			<img
				src={src}
				height={props.height}
				style={{
					height: props.height,
					aspectRatio: props.aspectRatio,
					width: props.height * props.aspectRatio,
					maxWidth: '100%',
					objectFit: props.objectFit ?? 'cover',
				}}
				className={props.className}
				alt={props.alt}
				fetchPriority={props.fetchPriority}
				loading={props.loading}
			/>
		);
	}

	return (
		<ImagePrimitive
			src={src}
			layout="constrained"
			height={props.height}
			aspectRatio={props.aspectRatio}
			className={props.className}
			alt={props.alt}
			priority={props.fetchPriority === 'high'}
			loading={props.loading}
			transformer={(src: string | URL, opts: { height?: number; width?: number }) =>
				generateImageSrc(src.toString(), opts)
			}
		/>
	);
}
